import { Component, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { Location } from '@angular/common';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { ModalComponent } from '../../../modal/modal.component';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { NexalesService } from '../../services/nexales.service';

@Component({
    selector: 'presentations-picker-modal',
    templateUrl: 'presentationsModal.component.html',
    standalone: false
})
export class PresentationsModalComponent extends BaseModalPageComponent {
  presentations: any[] = [];

  searchText: string = '';
  @ViewChild(NgModel, { static: false }) set searchInput(value: NgModel) {
    setTimeout(() =>
      value?.valueChanges
        .pipe(
          debounceTime(500),
          distinctUntilChanged(),
          switchMap((value) => {
            return this.nexalesService.fetchPresentations(value);
          })
        )
        .subscribe((val: any) => {
          if (val.presentations) {
            this.presentations = val.presentations;
          }
        })
    );
  }

  constructor(public selfModal: ModalComponent, location: Location, public nexalesService: NexalesService) {
    super(location);
  }

  public init(data: any) {
    this.initData();
  }

  initData() {
    this.nexalesService.fetchPresentations('').subscribe((val) => {
      if (val.presentations) {
        this.presentations = val.presentations;
      }
    });
  }

  public selectItem(presentation) {
    presentation.selected = !presentation.selected;
  }

  navigateTo(url) {
    window.open(url, '_blank').focus();
  }

  apply() {
    this.selfModal.close(this.presentations.filter((x) => x.selected));
  }

  reset() {
    this.selfModal.close([]);
  }
}
